export const VARIABLE_VALUE_REGEX = /(?<=\{)(\w+)(?=\})/g

export const patternHasFields = (pattern: string): boolean =>
  pattern.search(VARIABLE_VALUE_REGEX) >= 0
